<section class="profile-consent">

    <app-profile-section-header title="Comunicaciones"
                                subtitle="Personaliza qué tipo de comunicaciones deseas recibir y con qué frecuencia">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2"/>
            <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </app-profile-section-header>

    <article class="pc-row" [class.pc-row--active]="insuranceAdvertising">
        <span class="pc-row-icon" [class.pc-row-icon--active]="insuranceAdvertising">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                <path d="M6 8l-3 6h6l-3-6zM18 8l-3 6h6l-3-6zM12 3v18M5 21h14" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
        <div class="pc-row-text">
            <h3 [class.pc-row-title--active]="insuranceAdvertising">Publicidad de seguros</h3>
            <p>No estoy de acuerdo en que, previa evaluación de mis cualidades, se me ofrezca publicidad de seguros.</p>
        </div>
        <button type="button" class="pc-switch"
                role="switch"
                [class.pc-switch--on]="insuranceAdvertising"
                [attr.aria-checked]="insuranceAdvertising"
                [disabled]="running.insuranceAdvertising"
                (click)="toggle('insuranceAdvertising')">
            <span class="pc-switch-knob"></span>
        </button>
    </article>

    <article class="pc-row" [class.pc-row--active]="legalServicesAdvertising">
        <span class="pc-row-icon" [class.pc-row-icon--active]="legalServicesAdvertising">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                <path d="M7 3h8l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke-linejoin="round"/>
                <path d="M14 3v5h5M9 13h7M9 17h7" stroke-linecap="round"/>
            </svg>
        </span>
        <div class="pc-row-text">
            <h3 [class.pc-row-title--active]="legalServicesAdvertising">Publicidad de servicios legales</h3>
            <p>Acepto que onLygal Seguros ceda mis datos a la empresa del Grupo, onLygal Servicios Legales, S.L., para que esta me remita información publicitaria referida a servicios legales.</p>
        </div>
        <button type="button" class="pc-switch"
                role="switch"
                [class.pc-switch--on]="legalServicesAdvertising"
                [attr.aria-checked]="legalServicesAdvertising"
                [disabled]="running.legalServicesAdvertising"
                (click)="toggle('legalServicesAdvertising')">
            <span class="pc-switch-knob"></span>
        </button>
    </article>

</section>
